import { useRouter } from 'next/router';
import SupportContent from '@elem/compPage/Support';
import PageLayout from '@/components/PageLayout';
import { redirectTo404 } from '@/utils';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/support/index';
import IPRedirectLocal from 'eco-design-reliance/IPRedirect/IPRedirectLocal';
import { GetServerSidePropsContext } from 'next';

const whiteLocaleList = ['us', 'de', 'fr', 'jp', 'uk', 'eu', 'au', 'za', 'ca', 'es', 'it', 'kr', 'cn', 'tw', 'sa', 'br', 'mx', 'ph', 'nl'];
export default function Support({ lang, SEO }: any) {
    const { locale = '' } = useRouter();

    return (
        <PageLayout>
            <SEO title={lang.seo_title || lang.title} description={lang.seo_desc || ''} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            <SupportContent />
            <IPRedirectLocal route={'/support'} />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
